import React from 'react';

const StripeConnect = (props) => {
	const { setupConnectAccount, existingAccount, emphasize, isConnecting } = props;

	const rootClass = emphasize ? 'acms-stripe-connect acms-stripe-connect--emphasized' : 'acms-stripe-connect';

	const renderConnectButton = (label) => (
		<button
			type="button"
			className="button acms-stripe-connect__cta"
			onClick={ setupConnectAccount }
			disabled={ isConnecting }
			aria-busy={ isConnecting }
		>
			{ isConnecting && <span className="acms-stripe-connect__spinner" aria-hidden="true" /> }
			{ isConnecting ? 'Opening Stripe...' : label }
		</button>
	);

	const inner = () => {
		if (existingAccount) {
			const payoutsReady = existingAccount.muzado?.connect?.payoutsReady === true;

			return (
				<>
					<h3 className="acms-stripe-connect__title">Payouts (Stripe)</h3>
					{ !payoutsReady && (
						<>
							<p className="acms-stripe-connect__body">
								Finish connecting your free Stripe account to receive subscription payouts.
							</p>
							{ renderConnectButton('Continue to Stripe') }
						</>
					) }
					{ payoutsReady ? (
						<p className="acms-stripe-connect__body">Your Stripe account is connected and ready for payouts.</p>
					) : null }
				</>
			);
		}

		return (
			<>
				<h3 className="acms-stripe-connect__title">Payouts (Stripe)</h3>
				<p className="acms-stripe-connect__body">
					We use Stripe to pay you securely. Your bank details are stored with Stripe, not on Muzado.
				</p>
				{ renderConnectButton('Set up Stripe') }
			</>
		);
	};

	return (
		<div className={ rootClass }>
			{ inner() }
		</div>
	);
};

export default StripeConnect;
